import dayjs from 'dayjs';

const options = {
  taskList: {
    expander: {
      straight: true
    },
    columns: [
      {
        id: 1,
        label: 'Task',
        value: 'label',
        width: 200,
        html: true
      },
      {
        id: 2,
        label: 'Status',
        value: 'status',
        width: 100,
      },
      {
        id: 3,
        label: 'Category',
        value: 'category',
        width: 120,
      },
      {
        id: 4,
        label: 'Start Date',
        value: task => dayjs(task.start).format('YYYY-MM-DD'),
        width: 85
      },
      {
        id: 5,
        label: 'End Date',
        value: task => dayjs(task.end).subtract(1, 'day').format('YYYY-MM-DD'),
        width: 85
      },
      {
        id: 6,
        label: 'Developer',
        value: 'assignedUser',
        width: 100
      }
    ]
  },
  
  calendar: {
    workingDays: [1, 2, 3, 4, 5],
    hour: {
      display: false
    }
  },

  maxRows: 30,

  scope: {
    before: 0, // До первой задачи
    after: -1 // После последней задачи
  },

  chart: {
    grid: {
      horizontal: {
        gap: 1 // Отступ задач по высоте
      }
    },
    progress: {
      width: 20, // Ширина паттерна для фона
      height: 6, // Высота паттерна для фона
      pattern: true, //Паттер
      bar: false // Полоса сверху
    },
    expander: {
      display: true
    },
    // Текст рядом с задачей на графике справа
    text: {
      offset: 4, 
      xPadding: 10,
      display: false
    },
  },

  times: {
    timeScale: 60 * 1000,
    timeZoom: 20, //*
    timePerPixel: 0,
    firstTime: null,
    lastTime: null,
    firstTaskTime: 0,
    lastTaskTime: 0,
    totalViewDurationMs: 0, // Колличество миллисекунд от первой задачи до последней
    totalViewDurationPx: 0, // Колличество пикселей от первой задачи до последней
    stepDuration: 'day',
    steps: []
  },
}
export default options